import { SearchPartyStore } from '@App/stores/search/party/search-party-store'
import PartyResultsTable from '@Components/Search/SearchByParty/PartyResultsTable'
import { SearchResultPartyDetails } from '@Entities/party-details'
import SearchResultPartyDetailsCard from '@Components/Search/SearchByParty/SearchResultPartyDetailsCard'
import SearchByParty from '@Components/Search/SearchByParty'
import React, { useEffect } from 'react'
import { HasSearchCriteria } from '@App/stores/search/helpers/has-search-criteria'
import { useForm } from 'react-hook-form'
import PublisherSelectorDetailCard from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/PublisherSelector/PublisherSelectorDetailCard'

interface PublisherSelectorProps {
    store: SearchPartyStore<SearchResultPartyDetails> & HasSearchCriteria<Record<string, never>>
    onPublisherSelect: (publisher: SearchResultPartyDetails) => void
    defaultParty: string | undefined
}

interface PublisherSelectFormValues {
    party: string
}

const PublisherSelector = ({ store, onPublisherSelect, defaultParty }: PublisherSelectorProps) => {
    const { register, subscribe } = useForm<PublisherSelectFormValues>({ defaultValues: { party: defaultParty } })

    useEffect(() => {
        const callback = subscribe({
            name: 'party',
            formState: {
                values: true,
            },
            callback: ({ values }) => {
                const foundParty = store.searchResults.find((partyDetails) => partyDetails.ipId === values.party)
                if (!foundParty) {
                    throw new Error('Unable to find matching party details for selected IPID ' + values.party)
                }
                onPublisherSelect(foundParty)
            },
        })
        return () => callback()
    }, [subscribe])

    return (
        <SearchByParty
            searchPartyStore={store}
            partyDetailsCardComponent={SearchResultPartyDetailsCard} // TODO - I don't think this is necessary here, we should have one or the other, manual render vs pass the component
            renderPartyResultsTable={(onTitleClick, setLoading) => (
                <form>
                    <PartyResultsTable
                        searchPartyStore={store}
                        setLoading={setLoading}
                        onTitleClick={onTitleClick}
                        PartyDetailsCardComponent={({ partyDetails }) => (
                            <PublisherSelectorDetailCard
                                partyDetails={partyDetails}
                                onTitleClick={onTitleClick}
                                register={register}
                            />
                        )}
                    />
                </form>
            )}
        />
    )
}

export default PublisherSelector
